import ServiceBase from '@ekd/portal-connector/dist/Service';

import { createCheckAccessService } from './checkAccess.service';
import { createCheckAdFreeService } from './checkAdFree.service';
import { createGetPaymentMethodsService } from './getPaymentMethods.service';
import { createGetSubscriptionService } from './getSubscription.service';

import { ApiUrls } from '@root/common/types/apiUrls';
import { RootInstance } from '@root/plugins/instance-connector/RootInstance';

export function createPaywallService({ service, instances }: { service: ServiceBase<ApiUrls>; instances?: { root?: RootInstance } }) {
  const { checkAccess } = createCheckAccessService({ service });
  const { checkAdFree } = createCheckAdFreeService({ service });
  const { getPaymentMethods } = createGetPaymentMethodsService({ service, instances });
  const { getSubscription } = createGetSubscriptionService({ service });

  return {
    checkAccess,
    checkAdFree,
    getPaymentMethods,
    getSubscription,
  };
}
